// extracted by mini-css-extract-plugin
export default {"buttons":"regulated-or-listed-status_buttons__iw2iT","form":"regulated-or-listed-status_form__ToUoz"};